const FeatureFlags = {
  VIVINT_SMART_HOME_UI: "vivint_smart_home_ui_one",
  CONFIRM_INFO_SHOW_DESIGN_REQUEST:
    "sales-exp-confirm-info-show-design-request",
  STANDALONE_EV_CHARGER: "sales-exp-standalone-ev-charger",
  CHECKOUT_VERIFICATION_CALL: "sales-exp-checkout-verification-call",
  CHECKOUT_SRA: "sales-exp-checkout-sra",
  PERSONA_VERIFICATION: "sales-exp-persona-verification-odi",
  PERSONA_VERIFICATION_STATES: "sales-exp-persona-verification-by-state",
  PERSONA_TEMPLATE_ID: "sales-exp-persona-template-id",
  CPUC_INTERVAL_DATA_ENABLED: "cpuc-interval-data-enabled",
  CHECKOUT_COMBINED_ENVELOPE: "sales-exp-checkout-combined-envelope",
  INSIDE_SALES_VERIFICATION_CALL_ENABLED: "sales-exp-verification-call-for-air",
  PAYMENT_OUTAGE: "sales-exp-payment-outage",
  CONTRACT_REVIEW: "sales-exp-contract-review",
  UTILITY_PAST_DUE_BALANCE_FLOW_ENABLED:
    "sales-exp-show-utility-bill-past-due-banners",
  SPAN_AS_ACCESSORY: "sales-exp-span-as-accessory",
  NON_SOLAR_IHD_FLOW: "sales-exp-non-solar-ihd-flow",
  NON_SOLAR_IHD_BACK: "sales-exp-non-solar-ihd-back",
  PPC_SCHEDULING_IN_ONE: "sales-exp-ppc-scheduling-in-one",
  SELF_SUPPLY: "sales-exp-self-supply",
  REP_REDESIGN_AT_CAP: "sales-exp-rep-redesign-at-cap",
  REP_REDESIGN_IS_LIVE: "sales-exp-rep-redesign-is-live",
  NEW_OFFER_EXP_PROMOTIONS: "new-offer-exp-promotions",
  OFFER_REVIEW_SIMPLIFIED: "sales-exp-simple-presentation",
  CONTACT_VALIDATION_BLOCK_DOC_SIGNING:
    "sales-exp-contact-validation-block-doc-signing",
};

export { FeatureFlags };
